import React from 'react';
import { motion } from 'framer-motion';
import './WeFocusOn.css';

// Import 9 product UI screenshots
import img1 from '../assets/1.jpg';
import img2 from '../assets/2.jpg';
import img3 from '../assets/3.jpg';
import img4 from '../assets/4.jpg';
import img5 from '../assets/5.jpg';
import img6 from '../assets/6.jpg';
import img7 from '../assets/7.jpg';
import img8 from '../assets/8.jpg';
import img9 from '../assets/9.jpg';

const WeFocusOn = () => {
  const uiScreens = [img1, img2, img3, img4, img5, img6, img7, img8, img9];

  return (
    <section className="feature-section" id="weFocusOn">
      <div className="feature-description">
        <h2 className="title">Our Product in Action</h2>
        <p className="subtitle">
          Explore how EQ of AI protects your sensitive data with real-time detection,
          customizable alerts, and a powerful dashboard. Here’s a preview of our UI features:
        </p>
      </div>

      <div className="carousel-container">
        {uiScreens.map((img, index) => (
          <motion.div
            className="carousel-item"
            key={index}
            initial={{ opacity: 0, scale: 0.8, rotate: -5 }}
            whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.7, delay: index * 0.15, ease: "easeOut" }}
            whileHover={{ scale: 1.1, rotate: 2 }}
          >
            <div className="image-wrapper">
              <img src={img} alt={`UI ${index + 1}`} />
              <div className="gloss"></div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default WeFocusOn;
